import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-sign-up" }
const _hoisted_3 = { class: "s10_mobile container-full-2" }
const _hoisted_4 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_5 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_6 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_7 = { class: "form-field-split active my-5" }
const _hoisted_8 = { class: "form-field-floating lg reactive half" }
const _hoisted_9 = { class: "form-field-floating lg reactive half" }
const _hoisted_10 = { class: "form-field-floating lg reactive" }
const _hoisted_11 = { class: "s10_mobile container-full-2" }
const _hoisted_12 = { class: "grid2 grid-row-gap-0" }
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "card-check-text" }
const _hoisted_15 = ["id", "value"]
const _hoisted_16 = { class: "font-semibold mt-1 mb-2 align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "s20 form",
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _cache[19] || (_cache[19] = _createElementVNode("a", { href: "#" }, [
          _createElementVNode("div", { class: "text-center mb-8" }, [
            _createElementVNode("img", {
              src: "/public/images/logo-wide.svg",
              class: "auth-logo2"
            })
          ])
        ], -1)),
        _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "font-semibold mt-5 mb-4 text-center" }, "Enrôler votre collectivité", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-info-collectivite.svg",
              class: "size-l",
              alt: ""
            }),
            _createTextVNode(" Informations ")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              name: "designation",
              id: "designation",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.designation) = $event)),
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.designation]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "designation" }, [
              _createTextVNode("Désignation de la collectivité "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              name: "registre_commerce",
              id: "registre_commerce",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.registreCommerce) = $event)),
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.registreCommerce]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "registre_commerce" }, "Numéro du registre de commerce", -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              name: "adresse",
              id: "adresse",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.adresse) = $event)),
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.adresse]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "adresse" }, "Adresse de l'entreprise", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "telephone",
                id: "telephone",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.telephone) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.telephone]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("label", { for: "telephone" }, [
                _createTextVNode("Numéro de téléphone "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "hr" }, null, -1)),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: "form-input",
                name: "email",
                id: "email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.email) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.email]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("label", { for: "email" }, [
                _createTextVNode("Adresse Email "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-input",
              name: "date_creation",
              id: "date_creation",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.dateCreation) = $event)),
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.dateCreation]
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "date_creation" }, "Date de création", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-secteur-activite.svg",
              class: "size-l",
              alt: ""
            }),
            _createTextVNode(" Secteur d'activité ")
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secteurs, (secteur) => {
              return (_openBlock(), _createElementBlock("div", {
                key: secteur.id,
                class: "card-check lg single"
              }, [
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `secteur_${secteur.id}`
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input left",
                      type: "checkbox",
                      name: "secteur",
                      id: `secteur_${secteur.id}`,
                      value: secteur.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.secteursActivite) = $event))
                    }, null, 8, _hoisted_15), [
                      [_vModelCheckbox, _ctx.formData.secteursActivite]
                    ]),
                    _createElementVNode("h6", _hoisted_16, _toDisplayString(secteur.label), 1)
                  ])
                ], 8, _hoisted_13)
              ]))
            }), 128))
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("button", {
            type: "submit",
            class: "btn lg w-100 flex-center mt-2 mb-7"
          }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-valider.svg",
              class: "btn-icon",
              alt: ""
            }),
            _createElementVNode("span", null, "Créer votre compte")
          ], -1)),
          _createVNode(_component_router_link, { to: "/signin" }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createElementVNode("h5", { class: "text-primary-color text-center" }, "Vous avez déjà un compte ?", -1)
            ]))]),
            _: 1
          })
        ])
      ], 32)
    ])
  ]))
}